<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/EHivEI/tc-custom/9781467428842.jpg?1730410349577" alt="This image is the cover for the book The Lord and His Prayer"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Lord and His Prayer
      </h1>
      <p class="bookDescription body article font2">
        <p>In this book of pastoral reflections N.T. Wright explores how the Lord's Prayer sums up what Jesus was all about in his first-century setting. Wright locates the Lord's Prayer, clause by clause, within the historical life and work of Jesus and allows the prayer's devotional application to grow out of its historical context. The result is a fresh understanding of Christian spirituality and the life of prayer. This deeply devotional book will refresh and stimulate the heart and mind of any reader.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        N. T. Wright
      </h2>
      
      <p class="authorDescription body article">&#160;<BR /><B>N. T. Wright</B>, one of the most highly respected biblical scholars in the world today, is research professor emeritus of New Testament and early Christianity at the University of St. Andrews and senior research fellow at Wycliffe Hall, Oxford. He is the author of over eighty books, including&#160;<I>Simply Christian, Surprised by Hope, Paul and the Faithfulness of God</I>, and&#160;<I>The New Testament in Its World.</I></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?39edf551